<template>
  <div class="cont-box">
    <div class="header">
      <img src="../../assets/xuexi-bg.png" alt="" />
    </div>
    <div class="cont">
      <el-autocomplete class="inline-input" v-model="employeeName" :fetch-suggestions="querySearchAsync" placeholder="请输入姓名，至少2个字"
        @select="handleSelect" :trigger-on-focus="false" prefix-icon="el-icon-search"></el-autocomplete>
    </div>
    <div class="tip">
      <div v-if="flag" class="tip-cont">
        <p class="date">{{tipObj.period.replace("-"," 年 ")}} 月 <span style="font-size: 20px">积 分 情 况</span></p>
        <p><span>姓名：</span>{{tipObj.employeeName}}</p>
        <p><span>部门：</span>{{tipObj.dept}}</p>
        <p><span>本月积分：</span>{{tipObj.monthScore}}</p>
        <p><span>当前累计积分：</span> <span style="color: red;">{{tipObj.totalScore}}</span></p>
<!--        <p style="margin-top: 2em;color: gray;font-style: italic;font-weight: normal;font-size: 10px;"><span>数据更新时间：</span> {{tipObj.ctime}}</p>-->
      </div>
      <div v-else class="tip-cont tip-err">
        <p><span style="color: #dedede;">暂无数据</span></p>
      </div>
    </div>
  </div>
</template>

<script> 
  export default {
    name: 'IntegralM',
    data() {
      return {
        restaurants: [],
        employeeName: '',
        flag: false,
        tipObj: {}
      }
    },
    mounted() {
    },
    methods: {
      querySearchAsync(queryString, cb) {
        if(queryString.length < 2) return
        
        let data = {
          current: 1,
          size: 99,
          employeeName: queryString
        }
        this.$axios.post('/hr-learning-score/findListPage', data).then(res => {
          this.restaurants = res.data.data.records
          let restaurants = this.restaurants.map(item => {
            return {value: item.employeeName + '——' + item.dept, ...item}
          })
          var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
          cb(results)
        }).finally(() => {
          this.tipObj = {}
          this.flag = false
          })
      },
      createStateFilter(queryString) {
        return (state) => {
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        this.tipObj = item
        this.flag = true
        this.employeeName = this.tipObj.employeeName
      }
    },
  }
</script>

<style scoped>
  .header img {
    width: 100%;
  }

  .cont {
    display: flex;
    justify-content: center;
    padding: 20px;
  }

  .cont >>> .el-autocomplete {
    width: 100%;
    padding: 10px 10px 0;
  }

  .cont>>>.el-input__inner {
    border-radius: 20px;
    border: 1px solid #43a7ff;
  }
  
  .tip {
    margin: 10px 20px;
    border: 1px dashed #dedede;
    
    border-radius: 6px;
    background-color: #fafafa;
  }
  
  .tip-cont {
    display: flex;
    min-height: 200px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  .tip-cont p {
    line-height: 2.3em;
    font-weight: bold;
  }
  .tip-cont span {
    color: #646464;
  }

  .date {
    font-family: fangsong;
    font-size: 25px;
    /* text-align: left; */
    color: #fb5430;
    margin-bottom: 5px;
  }
</style>